import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router'
import Actions from '../../../actions'
import dayjs from 'dayjs'
import $t from '../../../i18n'
import { useRouteMatch } from 'react-router'
import FilePreviewPage from '../FilePreviewPage'
import config from '../../../config.json'
import Page from '../../common/Page'

import './ReferralResults.css'
import CardListView from '../../common/CardListView'
import { CARD_LIST_ITEM_IMAGE } from 'consts/CardListItemConsts'
import { capitalizeFirstLetter } from 'consts'

const ReferralResults = () => {
  const dispatch = useDispatch()
  const { path } = useRouteMatch()
  const hgTestResultsEnabled = useSelector(
    state => state.app.hgTestResultsEnabled
  )
  const questTestResults = useSelector(
    state => state.medicalInfo?.questReferralResults
  )
  const isLoading = useSelector(
    state => state.medicalInfo?.questReferralResultsLoading
  )
  const questResultsError = useSelector(
    state => state.medicalInfo?.questReferralResultsError
  )
  const selectedMemberId = useSelector(
    state => state.account?.selectedMember?.id
  )
  const [testResultsList, setTestResultsList] = useState([])

  const mapQuestTestResultToCardListItem = useCallback(
    testResult => {
      return {
        id: testResult?.result,
        issueDate: dayjs(testResult?.test_perfomed_date).format(
          config.questDateFormat
        ),
        title: $t('testResults.labQuest'),
        status: capitalizeFirstLetter(testResult?.status),
        subtitle: capitalizeFirstLetter(testResult?.name?.toLowerCase()),
        isPressable: !!testResult?.pdf,
        isSeen: testResult?.seen,
        patientId: testResult?.patient_id,
        file: testResult?.pdf,
        onClick: () => {
          dispatch(
            Actions.createAction(Actions.NAV_TO_REFERRAL_RESULT, testResult)
          )
        }
      }
    },
    [dispatch]
  )

  useEffect(() => {
    if (questTestResults) {
      const filteredSortedTestResults = questTestResults
        ?.filter(result =>
          selectedMemberId
            ? result?.patient_id?.toString() === selectedMemberId?.toString()
            : true
        )
        ?.map(mapQuestTestResultToCardListItem)
        ?.sort((a, b) => {
          return new Date(b?.issueDate) - new Date(a?.issueDate)
        })

      setTestResultsList(hgTestResultsEnabled ? filteredSortedTestResults : [])
    }
  }, [
    dispatch,
    questTestResults,
    selectedMemberId,
    hgTestResultsEnabled,
    mapQuestTestResultToCardListItem
  ])

  useEffect(() => {
    if (!questTestResults && !questResultsError) {
      dispatch(Actions.createAction(Actions.QUEST_REFERRALS_RESULTS_REQUESTED))
    }
  }, [dispatch, questTestResults, questResultsError])

  return (
    <div className='my-referral-results'>
      <Switch>
        <Route exact path={path}>
          <React.Fragment>
            <Page
              displayManageFamily
              title={$t('sideMenu.myReferralResults')}
              className='grey'
            >
              <CardListView
                data={testResultsList}
                category={$t('sideMenu.myReferralResults').toLowerCase()}
                isLoading={isLoading}
                dataName='view_results_clicked_web'
                imageName={CARD_LIST_ITEM_IMAGE.REFERRAL}
              />
            </Page>
          </React.Fragment>
        </Route>
        <Route path={`${path}/:fileId`}>
          <FilePreviewPage isDownloadEnable={true} />
        </Route>
      </Switch>
    </div>
  )
}

export default ReferralResults
